import { LocalLaundryService, Settings } from '@mui/icons-material';
import { Box, Card, CardContent, CardHeader, Checkbox, FormControlLabel, Switch, TextField, Typography } from '@mui/material';
import moment from "moment";
import { useState } from "react";
import { cardStyle } from '../../../theme';

export default function DNCSuppression(props) {
	const { formikProps, checkIndex, errors, touched, config } = props;

	const initialReassignment = formikProps.values.dncDotComSuppression?.reassignmentSince ?? '';
	const isRelativeInitial = (initialReassignment.startsWith?.('now-')) ?? false;
	const [isRelativeReassignmentDate, setIsRelativeReassignmentDate] = useState(isRelativeInitial);

	function isRelativeChange(isRelative) {
		setIsRelativeReassignmentDate(isRelative);

		if (isRelative) {
			formikProps.setFieldValue(`checks.${checkIndex}.dncDotComSuppression.reassignmentSince`, 'now-60');
		} else {
			formikProps.setFieldValue(`checks.${checkIndex}.dncDotComSuppression.reassignmentSince`, moment().format("YYYY-MM-DD"));
		}
	}

	function reassignmentFieldChange(e) {
		const val = e.target.value ?? '';
		if (isRelativeReassignmentDate) {
			formikProps.setFieldValue(`checks.${checkIndex}.dncDotComSuppression.reassignmentSince`, `now-${val}`);
		} else {
			formikProps.setFieldValue(`checks.${checkIndex}.dncDotComSuppression.reassignmentSince`, val);
		}
	}

	const reassignmentDisplayValue = (() => {
		const val = formikProps.values.checks?.[checkIndex]?.dncDotComSuppression?.reassignmentSince ?? '';
		return isRelativeReassignmentDate
			? val.startsWith('now-') ? val.substring(4) : val
			: val;
	})();

	return (
		<Box display='flex' flexDirection='column' gap={2}>
			<Card variant='outlined' sx={cardStyle}>
				<CardHeader title='Configuration' avatar={<Settings color='primary' fontSize='small' />} titleTypographyProps={{ style: { marginBottom: '4px' } }} />
				<CardContent>
					<Box display='flex' flexDirection='row' gap={2}>
						<TextField
							variant='outlined'
							label='Organization ID'
							value={config?.orgId ?? ''}
							disabled
						/>
						<TextField
							variant='outlined'
							label='Project ID'
							value={config?.projectId ?? ''}
							disabled
						/>
					</Box>
				</CardContent>
			</Card>

			<Card variant='outlined' sx={cardStyle}>
				<CardHeader title='Services' avatar={<LocalLaundryService color='primary' fontSize='small' />} titleTypographyProps={{ style: { marginBottom: '4px' } }} />
				<CardContent>
					<Box display='flex' flexDirection='column' gap={2}>
						{/* {formikProps.errors.dncDotComSuppression?.scrub &&
								<Box>
									<Typography variant='body1' color='error'>You must enable at least one service.</Typography>
								</Box>} */}
						{config.scrubEnabled && <>
							<FormControlLabel
								label='National and State DNC Scrub'
								control={<Switch
									checked={formikProps.values.checks?.[checkIndex]?.dncDotComSuppression?.scrub ?? false}
									onChange={() => formikProps.setFieldValue(`checks.${checkIndex}.dncDotComSuppression.scrub`, !formikProps.values.checks?.[checkIndex]?.dncDotComSuppression?.scrub)}
									color='primary'
									name='dncDotComSuppression.scrub'
								/>}
							/>

							<FormControlLabel
								label='Holiday/Emergency Declaration Check'
								control={<Switch
									checked={formikProps.values.checks?.[checkIndex]?.dncDotComSuppression?.state ?? false}
									onChange={() => formikProps.setFieldValue(`checks.${checkIndex}.dncDotComSuppression.state`, !formikProps.values.checks?.[checkIndex]?.dncDotComSuppression?.state)}
									color='primary'
									name='dncDotComSuppression.state'
								/>}
							/>
						</>}

						{config.reassignmentEnabled &&
							<Box display='flex' flexDirection='row' gap={2}>

								<FormControlLabel
									label='Number Reassignment'
									control={<Switch
										checked={formikProps.values.checks?.[checkIndex]?.dncDotComSuppression?.numberReassignment ?? false}
										onChange={() => formikProps.setFieldValue(`checks.${checkIndex}.dncDotComSuppression.numberReassignment`, !formikProps.values.checks?.[checkIndex]?.dncDotComSuppression?.numberReassignment)}
										color='primary'
										name='dncDotComSuppression.numberReassignment'
									/>}
								/>


								<Typography variant='body1'>since</Typography>

								{isRelativeReassignmentDate &&
									<>
										<Typography variant='body1' color='primary'>now</Typography>
										<Typography variant='body1' color='primary'>-</Typography>
									</>}

								<TextField
									variant='standard'
									type={isRelativeReassignmentDate ? "number" : 'date'}
									value={reassignmentDisplayValue}
									name={`checks.${checkIndex}.dncDotComSuppression.reassignmentSince`}
									onChange={reassignmentFieldChange}
									error={formikProps.touched.checks?.[checkIndex]?.dncDotComSuppression?.reassignmentSince && Boolean(formikProps.errors.checks?.[checkIndex]?.dncDotComSuppression?.reassignmentSince)}
								/>

								{isRelativeReassignmentDate && <Typography variant='body1'>days</Typography>}

								<FormControlLabel
									label='Relative'
									control={<Checkbox
										checked={isRelativeReassignmentDate}
										onChange={() => isRelativeChange(!isRelativeReassignmentDate)}
										color='primary'
									/>}
								/>
							</Box>}

						{config.knownLitigatorEnabled &&
							<FormControlLabel
								label='Known Litigator'
								control={<Switch
									checked={formikProps.values.checks?.[checkIndex]?.dncDotComSuppression?.knownLitigator ?? false}
									onChange={() => formikProps.setFieldValue(`checks.${checkIndex}.dncDotComSuppression.knownLitigator`, !formikProps.values.checks?.[checkIndex]?.dncDotComSuppression?.knownLitigator)}
									color='primary'
									name='dncDotComSuppression.knownLitigator'
								/>}
							/>}

							<FormControlLabel
								label='Check Only Fresh Contacts'
								control={<Switch
									checked={formikProps.values.checks?.[checkIndex]?.dncDotComSuppression?.checkOnlyFresh ?? false}
									onChange={() => formikProps.setFieldValue(`checks.${checkIndex}.dncDotComSuppression.checkOnlyFresh`, !formikProps.values.checks?.[checkIndex]?.dncDotComSuppression?.checkOnlyFresh)}
									color='primary'
									name='dncDotComSuppression.checkOnlyFresh'
								/>}
							/>
					</Box>
				</CardContent>
			</Card>
		</Box>
	);

}